/**
 * Auth Storage boshqaruvi:
 * Token va foydalanuvchi ma'lumotlarini faqat sessionStorage da saqlash.
 * Shunda brauzer yopilganda sessiya avtomatik o'chadi va qayta ochilganda
 * to'g'ridan-to'g'ri tizimga kirmasdan, har doim login va parol so'raladi.
 */

const AUTH_KEYS = new Set(["token", "user", "role", "name"]);

// 1. Dastur ishga tushganda localStorage da qolib ketgan eski doimiy token va userlarni tozalash
try {
  const origRemove = Storage.prototype.removeItem;
  AUTH_KEYS.forEach((key) => {
    origRemove.call(window.localStorage, key);
  });
} catch (e) {
  // Brauzer storage bloklagan bo'lsa xatoni yutish
}

// 2. localStorage orqali 'token', 'user', 'role', 'name' murojaat qilinganda
// ularni avtomatik ravishda sessionStorage ga yo'naltirish (mavjud komponentlar
// xatosiz va bir xil sessionStorage bilan ishlashi uchun)
const originalGetItem = Storage.prototype.getItem;
const originalSetItem = Storage.prototype.setItem;
const originalRemoveItem = Storage.prototype.removeItem;

Storage.prototype.getItem = function (key) {
  if (this === window.localStorage && AUTH_KEYS.has(key)) {
    return window.sessionStorage.getItem(key);
  }
  return originalGetItem.apply(this, arguments);
};

Storage.prototype.setItem = function (key, value) {
  if (this === window.localStorage && AUTH_KEYS.has(key)) {
    return window.sessionStorage.setItem(key, value);
  }
  return originalSetItem.apply(this, arguments);
};

Storage.prototype.removeItem = function (key) {
  // localStorage.removeItem faqat localStorage dan o'chirishi kerak,
  // sessionStorage ga aslo tegmasligi lozim!
  return originalRemoveItem.apply(this, arguments);
};

export function getAuthToken() {
  return window.sessionStorage.getItem("token");
}

export function setAuthToken(token) {
  window.sessionStorage.setItem("token", token);
}

export function getAuthUser() {
  const u = window.sessionStorage.getItem("user");
  try {
    return u ? JSON.parse(u) : null;
  } catch (e) {
    return null;
  }
}

export function setAuthUser(user) {
  window.sessionStorage.setItem("user", typeof user === "string" ? user : JSON.stringify(user));
}

export function clearAuth() {
  AUTH_KEYS.forEach((k) => {
    try {
      window.sessionStorage.removeItem(k);
      window.localStorage.removeItem(k);
    } catch (e) {}
  });
}
